module.exports = __webpack_public_path__ + "static/media/table-download-icon.7029f12b.svg";